import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import ModalImage from "react-modal-image";
import moment from "moment";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { api } from "../../../config";
import { useReactToPrint } from "react-to-print";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";
import { QRCodeSVG } from "qrcode.react";
import CountUp from "react-countup";
import CurrencyInput from "react-currency-input-field";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";

import { resetLegalState, getLegal } from "../../../store/legal/action";
import { resetBudgetState, getBudget } from "../../../store/budget/action";
import { resetDepartmentState, getDepartment } from "../../../store/department/action";
import { resetLegalStatusState, getLegalStatus } from "../../../store/legalStatus/action";
import { resetLegalFractionState, getLegalFraction as onGetLegalFractions, addNewLegalFraction as onAddNewLegalFraction, updateLegalFraction as onUpdateLegalFraction, deleteLegalFraction as onDeleteLegalFraction, getLegalFractionLoading, resetLegalFractionCreateState } from "../../../store/legalFraction/action";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { resetClientState, getClient } from "../../../store/client/action";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ModalInputFile from "../../../Components/ModalInputFile";
import defaultImg from "../../../assets/images/upload.png";
//import PrintDoc from "./PrintDoc";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { ButtonPrintF4, PrintDocF4 } from "./PrintDocF4";
import PrintDoc from "../../Task/PrintDoc";
import { getLegalMaster, getProductVarian, resetLegalMasterState, resetProductVarianState, setBranchSelect, setCompanySelect } from "../../../store/actions";

const LegalFraction = (props) => {
  const filerIdRef = useRef({
    branchId: 1,
  });
  const [pageIdx, setPageIdx] = useState(0);
  const [legalFractionalityDoc, setLegalFractionityDoc] = useState([]);
  const { t } = props;
  const printRef = useRef(null);
  const [logo, setLogo] = useState(defaultImg);
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalHistory, setModalHistory] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [indexPage, setIndexPage] = useState(0);
  const [placeValue, setPlaceValue] = useState("");
  const [legalMasterList, setLegalMasterList] = useState([]);
  const [locationCord, setLocationCord] = useState([-6.4577368, 106.9776222]);
  const [searchValue, setSearchValue] = useState("");
  const [modalAccPayable, setModalAccPayable] = useState(false);

  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, legalMasters, legalMasterLoading, legalFractions,
    legalFractionalAdded, isLegalFractionCreated, isLegalFractionSuccess, loading, error, legals, legalLoading, companies, companyLoading,
    clients, clientLoading, departments, departmentLoading, branches, branchLoading, legalStatus, legalStatusLoading,
    productVarians, productVarianLoading, budgets, budgetLoading } = useSelector((state) => ({
      clientSelected: state.App.clientSelected,
      companySelected: state.App.companySelected,
      branchSelected: state.App.branchSelected,
      userData: state.App.userData,
      userRole: state.App.userRole,
      userType: state.App.userType,
      legalFractionalAdded: state.LegalFraction.legalFractionalAdded,
      legalFractions: state.LegalFraction.legalFractions,
      loading: state.LegalFraction.loading,
      isLegalFractionCreated: state.LegalFraction.isLegalFractionCreated,
      isLegalFractionSuccess: state.LegalFraction.isLegalFractionSuccess,
      error: state.LegalFraction.error,
      companies: state.Company.companies,
      companyLoading: state.Company.loading,
      departments: state.Department.departments,
      departmentLoading: state.Department.loading,
      legalStatus: state.LegalStatus.legalStatus,
      legalStatusLoading: state.LegalStatus.loading,
      legals: state.Legal.legals,
      legalLoading: state.Legal.loading,
      legalMasters: state.LegalMaster.legalMasters,
      legalMasterLoading: state.LegalMaster.loading,
      branches: state.Branch.branches,
      branchLoading: state.Branch.loading,
      budgets: state.Budget.budgets,
      budgetLoading: state.Budget.loading,
      clients: state.Client.clients,
      clientLoading: state.Client.loading,
      productVarians: state.ProductVarian.productVarians,
      productVarianLoading: state.ProductVarian.loading,
    }));

  const [detailType, setDetailType] = useState(null);

  const [legalFractionalList, setLegalFractionList] = useState([]);
  const [legalFractional, setLegalFraction] = useState([]);
  const [legalFractionalUpdate, setLegalFractionUpdate] = useState(null);
  const [info, setInfo] = useState([]);
  const [assetFiles, setAssetFiles] = useState([]);
  const [profileFiles, setProfileFiles] = useState([]);
  const [detailFiles, setDetailFiles] = useState([]);

  const [isExportCSV, setIsExportCSV] = useState(false);
  const [budgetList, setBudgetList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [filterDate, setFilterDate] = useState();

  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [currentImage, setCurrentImage] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(false);

  const [departmentData, setUserData] = useState(null);
  const [legalStatusList, setLegalStatusList] = useState([]);
  const [legalProgressList, setLegalProgressList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);

  const [positionMessage, setPositionMessage] = useState("");

  const [modalMedia, setModalMedia] = useState(false);
  const [docImg, setDocImg] = useState([]);
  const [checkDocumentList, setCheckDocumentList] = useState([]);
  const [searchBranch, setSearchBranch] = useState("");

  const [blockList, setBlockList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [branchIdSelected, setBranchIdSelected] = useState(null);

  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredLegalFractions = legalFractions;
      if (type !== "all") {
        filteredLegalFractions = legalFractions.filter((legalFractional) => legalFractional.lf_status_legal.id.toString() === type.toString());
      }
      setLegalFractionList(filteredLegalFractions);
    }
  };

  useEffect(() => {
    if (branchSelected) {
      setBranchIdSelected(branchSelected.value);
      setPositionMessage(`${userData?.user.user_user && userData?.user.user_user.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
      handleGetLegalFraction(companySelected?.value ?? "", branchSelected?.value ?? "");
    }
  }, [branchSelected]);

  const handleGetLegalFraction = (id, branchId) => {
    dispatch(resetLegalFractionState());
    dispatch(onGetLegalFractions(branchId ? { companyId: id, branchId: branchId } : { companyId: id, ...filerIdRef.current }));
    handleGetProductVariant(id);
    handleGetDepartment(id);
    handleGetLegalStatus();
    handleGetLegalMaster(id);
    handleGetBudget(id, branchId);
  };

  const handleGetBudget = (companyId, branchId) => {
    dispatch(resetBudgetState());
    dispatch(getBudget({ companyId: companyId, status: 2, branchId: branchId, simple: true }));
  };

  const handleGetLegalMaster = (id) => {
    dispatch(resetLegalMasterState());
    dispatch(getLegalMaster({ companyId: id }));
  };

  const handleGetDepartment = (companyId) => {
    dispatch(resetDepartmentState());
    dispatch(getDepartment({ companyId: companyId }));
  };

  const handleGetLegalStatus = () => {
    dispatch(resetLegalStatusState());
    dispatch(getLegalStatus({ type: "pecahan" }));
  };

  const handleGetProductVariant = (companyId) => {
    dispatch(resetProductVarianState());
    dispatch(getProductVarian({ companyId: companyId, type: "referral" }));
  };

  useEffect(() => {
    if (!isEmpty(legalFractions)) {
      let filteredLegalFractions = [];
      for (const data of legalFractions) {
        if (data instanceof Array) {
          for (const dd of data) filteredLegalFractions.push(dd);
        }
        else {
          filteredLegalFractions.push(data);
        }
      }
      if (activeTypeTab !== "all") {
        filteredLegalFractions = (legalFractions.data || legalFractions || []).filter((legalFractional) => legalFractional.lf_status_legal.id.toString() === activeTypeTab.toString());
      }

      setLegalFractionList(filteredLegalFractions.map((el) => ({ ...el, isChecked: false })));
      const data = filteredLegalFractions[filteredLegalFractions.length - 1];
      if (info && info?.id) {
        for (const obj of filteredLegalFractions) {
          if (obj.id === info.id) {
            setInfo(obj);
            let files = [];
            if (Array.isArray(obj.lf_file)) {
              for (const f of obj.lf_file) {
                files.push({ filename: f.filename, originalname: f.originalname });
              }
            }
            setAssetFiles(files);
            setLocationCord([obj?.latitude, obj?.longitude]);
          }
        }
      } else {
        setInfo(data);
        let files = [];
        if (Array.isArray(data.lf_file)) {
          for (const f of data.lf_file) {
            files.push({ filename: f.filename, originalname: f.originalname });
          }
        }
        setAssetFiles(files);
        setLocationCord([data?.latitude, data?.longitude]);
      }
    }
  }, [legalFractions]);

  useEffect(() => {
    if (!isEmpty(productVarians)) {
      var productVarianData = [];
      var blockData = [];
      var opt = [];
      var block = [];
      productVarians.forEach((item) => {
        const varian = item.pvar_product;
        const blck = varian.product_block ? varian.product_block.id : "-";
        const blck_name = varian.product_block ? varian.product_block.name : "-";
        const name = blck_name + "-" + varian.name;
        const id = item.id;
        const barcode = item.barcode;
        const sku = item.sku;
        const brandId = item.brandId;
        const productId = item.productId;
        const branch = varian.branchId ? varian.branchId : "-";

        if (item.typeId === 1) {
          if (branchIdSelected === branch) {
            opt.push({ label: name, name: name, isHook: false, barcode: barcode, sku: sku, value: productId, brandId: brandId, productId: productId, productVarianId: id });
            const dataBlock = block.find((d) => d.value === blck);
            if (!dataBlock) block.push({ label: blck_name, value: blck });

            if (item.land_excess > 0) {
              opt.push({ label: name + 'A', name: name + 'A', isHook: true, barcode: barcode, sku: sku, value: productId, brandId: brandId, productId: productId, productVarianId: id });
              const dataBlock = block.find((d) => d.value === blck);
              if (!dataBlock) block.push({ label: blck_name, value: blck });
            }
          }
        }
      });

      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
      productVarianData.push(option);
      setProductList(productVarianData);

      var option_block = { options: block.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
      blockData.push(option_block);
      setBlockList(blockData);
    }
  }, [productVarians, branchIdSelected]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "NAMA",
        isSelected: true,
        data: [],
      },
      {
        id: "luas",
        label: "LUAS",
        isSelected: true,
        data: [],
      },
      {
        id: "njop",
        label: "HARGA",
        isSelected: true,
        data: [],
      },

      {
        id: "description",
        label: "KETERANGAN",
        isSelected: true,
        data: [],
      },
    ];

    if (legalFractionalList.length > 0) {
      legalFractionalList.forEach((data) => {
        if (data.isChecked) {
          let doc = dataDoc.find((d) => d.id === "code");
          if (doc) doc.data.push(data.code);

          doc = dataDoc.find((d) => d.id === "name");
          if (doc) doc.data.push(data.name);

          doc = dataDoc.find((d) => d.id === "luas");
          if (doc) doc.data.push(data.luas);

          doc = dataDoc.find((d) => d.id === "owner");
          if (doc) doc.data.push(data.owner);

          doc = dataDoc.find((d) => d.id === "quantity");
          if (doc) doc.data.push(data.quantity ?? 0);

          doc = dataDoc.find((d) => d.id === "njop");
          if (doc) doc.data.push(data.njop ?? 0);

          doc = dataDoc.find((d) => d.id === "price");
          if (doc) doc.data.push(data.price ?? 0);

          doc = dataDoc.find((d) => d.id === "description");
          if (doc) doc.data.push(data.description);
        }
      });
    }

    setLegalFractionityDoc(dataDoc);
  }, [legalFractionalList]);

  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  useEffect(() => {
    if (!isEmpty(branches)) {
      var data = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setBranchList(data);
    }
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(budgets)) {
      var data = [];
      var opt = [{ label: "", value: "" }];
      budgets.forEach((item, key) => {
        const name = item.type + ' - ' + item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setBudgetList(data);
    } else {
      setBudgetList([]);
    }
  }, [budgets]);

  useEffect(() => {
    if (filerIdRef.current && branchList.length > 0) {
      const branchSelectedDefault = branchList[0].options.find((data) => data.value === filerIdRef.current.branchId);
      setSearchBranch(branchSelectedDefault);
    }
  }, [branchList]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(departments)) {
      var data = [];
      var opt = [];
      departments.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
    }

    if (departments.length > 0) {
      setDepartmentList(data);
    }
  }, [departments]);

  useEffect(() => {
    if (!isEmpty(legalStatus)) {
      var pecahan = [];
      var progresspecahan = [];
      var optprogresspecahan = [];
      var optpecahan = [];
      legalStatus.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        const type = item.type;
        var obj = { label: name, value: id, type: type };
        if (type === "pecahan")
          optpecahan.push(obj);
        if (type === "progresspecahan")
          optprogresspecahan.push(obj);
      });
      var optionpecahan = { options: optpecahan };
      pecahan.push(optionpecahan);

      var optionprogresspecahan = { options: optprogresspecahan };
      progresspecahan.push(optionprogresspecahan);

      setLegalStatusList(pecahan);
      setLegalProgressList(progresspecahan);
    }

  }, [legalStatus]);

  const onClickDelete = (legalFractional) => {
    setLegalFraction(legalFractional);
    setDeleteModal(true);
  };

  const handleDeleteLegalFraction = () => {
    if (legalFractional) {
      dispatch(onDeleteLegalFraction(legalFractional));
      setDeleteModal(false);
    }
  };

  const toggleAccPayable = useCallback(() => {
    if (modalAccPayable) {
      setModalAccPayable(false);
    } else {
      setModalAccPayable(true);
    }
  }, [modalAccPayable]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setLegalFraction(null);
      setAssetFiles([]);
      setDocImg([]);
      validation.resetForm();
    } else {
      setModal(true);
    }
  }, [modal]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const toggleHistory = useCallback(() => {
    if (modalHistory) {
      setModalHistory(false);
    } else {
      setModalHistory(true);
    }
  }, [modalHistory]);

  const toggleDetail = useCallback(
    (type) => {
      if (modalDetail) {
        setModalDetail(false);
        setDetailType(null);
      } else {
        setModalDetail(true);
        setDetailType(type);
      }
    },
    [modalDetail]
  );

  const handleLegalFractionClick = useCallback((arg, type) => {
    const data = arg;
    let files = [];
    if (Array.isArray(data.lf_file)) {
      for (const f of data.lf_file) {
        files.push({ filename: f.filename, originalname: f.originalname });
      }
    }
    setAssetFiles(files);

    setLegalFractionUpdate({
      id: data.id,
      branch: data.lf_branch && { label: data.lf_branch.name, value: data.lf_branch.id },
      company: data.lf_company && { label: data.lf_company.name, value: data.lf_company.id },
      client: data.lf_client && { label: data.lf_client.name, value: data.lf_client.id },
      lf_status_legal: data.lf_status_legal && {
        label: data.lf_status_legal.name,
        value: data.lf_status_legal.id,
      },
      legalmaster: data.legalmaster,
      land_size: data.land_size,
      name: data.name,
      productId: data.productId,
      behalf_company: data.behalf_company,
      behalf_customer: data.behalf_customer,
      targetat: data.targetat,
      description: data.description,
      mailing: data.mailing,
      isHook: data.isHook,
      nibel: data.nibel,
    });

    setIsEdit(true);
    toggle();
  },
    [toggle, legals]
  );

  const handleSalesClick = useCallback(
    (type) => {
      toggleDetail(type);
    },
    [toggleDetail, userType]
  );

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = legalFractionalList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setLegalFractionList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(() => [{
    Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      return (
        <div className="hstack gap-2 mt-4 mt-sm-0">
          <input
            type="checkbox"
            className="dataCheckbox me-2 form-check-input"
            checked={legalFractionalList.find((x) => x.id === data.id).isChecked}
            onChange={() => {
              const updatedData = legalFractionalList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
              setLegalFractionList(updatedData);
            }}
          />
          <ButtonGroup className="me-1">
            <UncontrolledButtonDropdown>
              <Button
                color="light"
                className="btn-sm"
                onClick={() => {
                  setInfo(data);
                  let files = [];
                  if (Array.isArray(data.lf_file)) {
                    for (const f of data.lf_file) {
                      files.push({ filename: f.filename, originalname: f.originalname });
                    }
                  }
                  setAssetFiles(files);
                  console.log(files)
                }}
              >
                <i className="ri-eye-line fs-15"></i>
              </Button>
              <Button
                color="light"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateLegal") !== -1 ? "btn-sm" : "btn-sm d-none"}
                onClick={() => {
                  handleLegalFractionClick(data);
                }}
              >
                <i className="ri-edit-2-line fs-15"></i>
              </Button>
              <Button
                color="light"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteLegal") !== -1 ? "btn-sm" : "btn-sm d-none"}
                onClick={() => {
                  data.statusId = 3;
                  onClickDelete(data);
                }}
              >
                <i className="ri-delete-bin-line fs-15 text-danger"></i>
              </Button>
              {/* <DropdownToggle tag="button" className={userType === "admin" || userType === "client" ? "btn btn-sm btn-light" : userRole && userRole.split(",").indexOf("updateLegal") !== -1 ? "btn btn-sm btn-light" : "btn btn-sm btn-light d-none"} split></DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("surat-permohonan");
                  }}>
                  SURAT PERMOHONAN PENGUKURAN
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("surat-pernyataan-fisik-bidang-tanah");
                  }}>
                  SURAT PERNYATAAN PENGUASAAN FISIK BIDANG TANAH
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("surat-tanda-terima-pengukuran");
                  }}>
                  TANDA TERIMA BERKAS PERMOHONAN PENGUKURAN
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("surat-pernyataan-batas");
                  }}>
                  PRINT SURAT PERNYATAAN PEMASANGAN TANDA BATAS
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("print-sk-penetapan");
                  }}>
                  PRINT SK PENETAPAN
                </DropdownItem>
              </DropdownMenu> */}
            </UncontrolledButtonDropdown>
          </ButtonGroup>
        </div>
      );
    },
    id: "#",
  },
  {
    Header: "Proper",
    accessor: "lf_branch",
    filterable: true,
    Cell: (data) => <span className="fw-semibold">{data?.value?.name}</span>,
  },
  {
    Header: "Jenis Pecahan",
    accessor: "lf_status_legal",
    filterable: true,
    Cell: (cell) => {
      let status;
      let data = cell.row.original;
      switch (data?.lf_status?.name) {
        case "DRAFT":
          status = <span className="badge fs-10 text-uppercase badge-soft-warning"> {data?.lf_status?.name} </span>;
          break;
        case "ACTIVE":
          status = <span className="badge fs-10 text-uppercase badge-soft-info"> {data?.lf_status?.name} </span>;
          break;
        case "INACTIVE":
          status = <span className="badge fs-10 text-uppercase badge-soft-danger"> {data?.lf_status?.name} </span>;
          break;
        default:
          status = <span className="badge fs-10 text-uppercase badge-soft-warning"> {data?.lf_status?.name} </span>;
          break;
      }

      return <div><span className="badge fw-normal fs-11" style={{ backgroundColor: cell?.value?.color, color: "#FFF  " }}>{cell?.value?.name}</span> {status}</div>
    },
  },
  {
    Header: "Blok",
    accessor: "name",
    filterable: true,
    Cell: (data) => <span className="fw-semibold">{data.value}</span>,
  },
  {
    Header: "Dasar Induk",
    accessor: "legalmaster",
    filterable: true,
    Cell: (cell) => {
      let data = cell.row.original;
      let val = "";
      for (const element of (data.legalmaster || [])) {
        val = val + element.label + ", "
      }
      return val.replace(/[, \s]+$/, "");
    },
  },
  {
    Header: "Atas Nama",
    accessor: "behalf_company",
    filterable: true,
    Cell: (data) => <span className="fw-semibold">{data.value}</span>,
  }], [legalFractionalList, handleLegalFractionClick, toggleHistory, userRole, userType, isCheckAll]);

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = legalFractionalList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setLegalFractionList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => legalFractionalList, [legalFractionalList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Department"],
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  useEffect(() => {
    setIndexPage(pageIndex);
  }, [pageIndex]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      type: "requested",
      branchId: branchSelected?.value ?? "",
    };
    dispatch(onGetLegalFractions(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setLegalMasterList([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    handleGetLegalFraction(companySelected?.value ?? "", branchSelected?.value ?? "");
  };

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteLegalFraction(element.value));
    });
    checkall.checked = false;
  };

  function handleLegalFractionDetailAdd(type) {
    if (type === "profile") setProfileFiles([...profileFiles, { filename: "", originalname: "", description: "" }]);
    else setDetailFiles([...detailFiles, { filename: "", originalname: "", description: "" }]);
  }

  const handleSelectFile = (file) => {
    if (currentImage === "detail") {
      detailFiles[currentImageIndex].filename = file.filename;
      detailFiles[currentImageIndex].originalname = file.originalname;
    } else if (currentImage === "profile") {
      profileFiles[currentImageIndex].filename = file.filename;
      profileFiles[currentImageIndex].originalname = file.originalname;
    } else {
      setAssetFiles((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    }
    setCurrentImage(null);
    setCurrentImageIndex(null);
    toggleMedia();
  };

  const renderIcon = (fileName) => {
    const type = fileName.split(".");
    switch (type[type.length - 1]) {
      case "sheet":
        return <i className="ri-file-excel-line me-1 align-bottom text-success"></i>;
      case "x-compressed":
        return <i className="ri-file-zip-line me-1 align-bottom text-danger"></i>;
      case "pdf":
        return <i className="ri-file-pdf-line me-1 align-bottom text-danger"></i>;
      default:
        return <ModalImage showRotate={true} small={`${api.MEDIA_URL}/media/${fileName}-w-50`} large={`${api.MEDIA_URL}/media/${fileName}`} alt={info.name} className="img-thumbnail avatar-xs img-thumbnail user-profile-image" />;
    }
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (legalFractional && legalFractional.id) || 0,
      company: (legalFractional && legalFractional.company) || companySelected,
      lf_status_legal: (legalFractional && legalFractional.lf_status_legal) ?? "",
      client: (legalFractional && legalFractional.client) || clientSelected,
      branch: (legalFractional && legalFractional.branch) || (branchSelected?.value === "all" ? "" : branchSelected),
      legalmaster: (legalFractional && legalFractional.legalmaster) || [],
      block: (legalFractional && legalFractional.block) || [],
      unit: (legalFractional && legalFractional.unit) || [],
      behalf_company: (legalFractional && legalFractional.behalf_company) ?? "",
      behalf_customer: (legalFractional && legalFractional.behalf_customer) ?? "",
      name: (legalFractional && legalFractional.name) ?? "",
      description: (legalFractional && legalFractional.description) ?? "",
      isHook: (legalFractional && legalFractional.isHook) || false,
      land_size: (legalFractional && legalFractional.land_size) || 0,
      nibel: (legalFractional && legalFractional.nibel) ?? "",
      statusId: 1,
    },
    validationSchema: Yup.object({
      company: Yup.object().required("Silahkan isi Perusahaan").nullable(true),
      client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
      branch: Yup.object().required("Silahkan isi Cabang").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getLegalFractionLoading());
      let addSubmit = {
        branchId: values.branch.value,
        clientId: values.client.value,
        companyId: values.company.value,
        legalmaster: values.legalmaster,
        statusLegalId: values.lf_status_legal.value,
        name: values.name,
        unit: values.unit,
        block: values.block,
        behalf_company: values.behalf_company,
        behalf_customer: values.behalf_customer,
        description: values.description,
        nibel: values.nibel,
        land_size: values.land_size,
        isHook: values.isHook,
        statusId: 1,
        files: assetFiles.length > 0 ? assetFiles : [],
      };
      dispatch(onAddNewLegalFraction(addSubmit));
      validation.resetForm();
      toggle();
    },
  });

  const validationEdit = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (legalFractionalUpdate && legalFractionalUpdate.id) || 0,
      company: (legalFractionalUpdate && legalFractionalUpdate.company) || companySelected,
      client: (legalFractionalUpdate && legalFractionalUpdate.client) || clientSelected,
      branch: (legalFractionalUpdate && legalFractionalUpdate.branch) || branchSelected,
      lf_status_legal: (legalFractionalUpdate && legalFractionalUpdate.lf_status_legal) ?? "",
      name: (legalFractionalUpdate && legalFractionalUpdate.name) ?? "",
      productId: (legalFractionalUpdate && legalFractionalUpdate.productId) ?? "",
      behalf_company: (legalFractionalUpdate && legalFractionalUpdate.behalf_company) ?? "",
      behalf_customer: (legalFractionalUpdate && legalFractionalUpdate.behalf_customer) ?? "",
      legalmaster: (legalFractionalUpdate && legalFractionalUpdate.legalmaster) || [],
      targetat: (legalFractionalUpdate && legalFractionalUpdate.targetat) ?? "",
      description: (legalFractionalUpdate && legalFractionalUpdate.description) ?? "",
      mailing: (legalFractionalUpdate && legalFractionalUpdate.mailing) || {},
      isHook: (legalFractionalUpdate && legalFractionalUpdate.isHook) || false,
      land_size: (legalFractionalUpdate && legalFractionalUpdate.land_size) || 0,
      nibel: (legalFractionalUpdate && legalFractionalUpdate.nibel) ?? "",
    },
    validationSchema: Yup.object({
      company: Yup.object().required("Silahkan isi Perusahaan").nullable(true),
      client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
      branch: Yup.object().required("Silahkan isi Cabang").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getLegalFractionLoading());
      if (isEdit) {
        let editSubmit = {
          id: values.id,
          statusLegalId: values.lf_status_legal.value,
          name: values.name,
          branchId: values.branch.value ?? null,
          companyId: values.company.value ?? null,
          clientId: values.client.value ?? null,
          productId: values.productId,
          behalf_company: values.behalf_company,
          behalf_customer: values.behalf_customer,
          targetat: values.targetat,
          description: values.description,
          mailing: values.mailing,
          nibel: values.nibel,
          land_size: values.land_size,
          isHook: values.isHook,
          files: assetFiles.length > 0 ? assetFiles : [],
        };
        dispatch(onUpdateLegalFraction(editSubmit));
      }
      validationEdit.resetForm();
      toggle();
    },
  });

  const validationAccPayable = useFormik({
    enableReinitialize: true,
    initialValues: {
      amount: 0,
      account: "",
      cashflow: "",
      description: `TANAH DALAM PENGEMBANGAN ${info?.legal_nominatif?.nama + " - " + info?.name}`,
      transactionat: moment().format("YYYY/MM/DD"),
    },
    validationSchema: Yup.object({
      amount: Yup.string().required("Please Pick Amount"),
      cashflow: Yup.object().required("Silahkan isi Anggaran Cashflow").nullable(true)
    }),
    onSubmit: (values) => {
      dispatch(getLegalFractionLoading());
      info.setAccPayable = true;
      info.setApprove = false;
      info.transactionat = values.transactionat;
      info.budgetId = values.cashflow.value;
      info.accType = "PAYABLE";
      info.description = values.description;
      info.amount = values.amount;
      dispatch(onUpdateLegalFraction(info));
      validationAccPayable.resetForm();
      toggleAccPayable();
    },
  });

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = assetFiles.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setAssetFiles(newState);
    } else {
      const index = assetFiles.findIndex((fl) => fl.filename === file.filename);
      setAssetFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  useEffect(() => {
    if (!isEmpty(legalMasters)) {
      var data = [];
      var opt = [{ label: "Select All", value: "all" }];
      legalMasters.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = {
          label: name,
          value: id,
        };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);

      setLegalMasterList(data);
    }
  }, [legalMasters]);

  document.title = "Sertifikat Pecahan | Enterprise Resources Planning";

  return (
    <>
      <div className="page-content">
        <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={legalFractionalList} />
        <DeleteModal show={deleteModal} onDeleteClick={handleDeleteLegalFraction} onCloseClick={() => setDeleteModal(false)} />
        <DeleteModal
          show={deleteModalMulti}
          onDeleteClick={() => {
            deleteMultiple();
            setDeleteModalMulti(false);
          }}
          onCloseClick={() => setDeleteModalMulti(false)} />
        <Container fluid>
          <BreadCrumb title="Pertanahan" pageTitle="Sertifikat Pecahan" loading={loading}>
            <div className="flex-shrink-0">
              <button
                type="button"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createLegal") !== -1 ? "btn btn-primary add-btn me-2" : "d-none"}
                id="create-btn"
                onClick={() => {
                  setIsEdit(false);
                  let arrLegalFraction = [];
                  for (const d of legals) arrLegalFraction.push({ id: 0, name: d.name, targetat: "", actualat: "", description: "" });
                  setCheckDocumentList(arrLegalFraction);
                  validation.setFieldValue("legalFractionality", arrLegalFraction);
                  toggle();
                }}>
                <i className="ri-archive-line me-1 align-bottom fs-14"></i> Tambah
              </button>
              <ExportDoc data={legalFractionalityDoc} />
            </div>
          </BreadCrumb>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody className="pt-0 pb-0">
                  <div>
                    <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                      <NavItem>
                        <NavLink
                          className={activeTab === "1" ? "fw-semibold px-2 active" : "px-2"}
                          onClick={() => {
                            toggleTab("1", "all");
                          }}
                          href="#" >
                          <i className="ri-file-list-3-line me-1 align-bottom fs-14"></i> SEMUA DATA SERTIFIKAT PECAHAN
                        </NavLink>
                      </NavItem>
                      {legalStatus.filter(f => f.type === 'pecahan').map((o, i) => (
                        <NavItem key={i}>
                          <NavLink
                            className={activeTab === i + 2 ? "fw-semibold px-2 active" : "px-2"}
                            onClick={() => {
                              toggleTab(i + 2, o.id);
                            }}
                            href="#">
                            <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> {o.name}
                          </NavLink>
                        </NavItem>
                      ))}
                    </Nav>
                    <Row className="mb-0">
                      <CardBody className="pb-0">
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-3 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={9}>
                            <div className="search-box me-2 mb-3 d-inline-block col-12">
                              <input
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                onChange={(e) => {
                                  setLegalFractionList(legalFractions.map((el) => ({ ...el, isChecked: false })));
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                placeholder={`${countSearch} Cari...`}
                                value={searchValue ?? ""} />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}>
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}>
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg={9}>
              <Card>
                <CardBody>
                  <div>
                    <div className="table-responsive table-card mb-1" style={{ minHeight: "380px" }}>
                      <Table hover {...getTableProps()} className="align-middle table-nowrap">
                        <thead className="table-info">
                          {headerGroups.map((headerGroup, index) => (
                            <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                              {headerGroup.headers.map((column, index) => (
                                <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                  {column.render("Header")}
                                  {generateSortingIndicator(column)}
                                  {/* <Filter column={column} /> */}
                                </th>
                              ))}
                            </tr>
                          ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                          {page.map((row) => {
                            prepareRow(row);
                            return (
                              <Fragment key={row.getRowProps().key}>
                                <tr>
                                  {row.cells.map((cell, index) => {
                                    return (
                                      <td {...cell.getCellProps()} key={index}>
                                        {cell.render("Cell")}
                                      </td>
                                    );
                                  })}
                                </tr>
                              </Fragment>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>

                    <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                      <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                      <Col className="col-md-auto">
                        <div className="d-flex gap-1">
                          <Button
                            className="btn btn-light"
                            onClick={() => {
                              setPageIdx(pageIndex - 1);
                              previousPage();
                            }}
                            disabled={!canPreviousPage}>
                            {"<"}
                          </Button>
                        </div>
                      </Col>
                      <Col className="col-md-auto d-none d-md-block">
                        Halaman {pageIndex + 1} dari {pageOptions.length}
                      </Col>
                      <Col className="col-md-auto">
                        <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                      </Col>
                      <Col className="col-md-auto">
                        <div className="d-flex gap-1">
                          <Button
                            className="btn btn-light"
                            onClick={() => {
                              setPageIdx(pageIndex + 1);
                              nextPage();
                            }}
                            disabled={!canNextPage}>
                            {">"}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <Modal id="showModal" isOpen={modal} centered size="xl">
                    <ModalHeader className="bg-light p-3" toggle={toggle}>
                      {!!isEdit ? "Edit Sertifikat Pecahan" : "Tambah Sertifikat Pecahan"}
                    </ModalHeader>
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        if (isEdit) {
                          validationEdit.handleSubmit();
                        } else {
                          validation.handleSubmit();
                        }

                        return false;
                      }}>
                      <ModalBody>
                        <CardBody className="border-bottom p-2 pt-0 pb-0 border-bottom-dashed">
                          <Row>
                            {isEdit ? (
                              <>
                                <Col lg={5}>
                                  <div className="mb-3">
                                    <Label htmlFor="client-field" className="form-label">
                                      Grup Usaha
                                    </Label>
                                    <div className="position-relative">
                                      <Select
                                        name="client"
                                        value={validationEdit.values.client}
                                        isDisabled={userType === "admin" || userType === "client" ? false : true}
                                        placeholder="Pilih Grup Usaha"
                                        onChange={(e) => {
                                          validationEdit.setFieldValue("client", e);
                                        }}
                                        options={clientList}></Select>
                                      <div
                                        className="position-absolute"
                                        style={{
                                          top: "12px",
                                          left: "-24px",
                                        }}>
                                        {clientLoading && (
                                          <Spinner color="primary" size="sm">
                                            Loading...
                                          </Spinner>
                                        )}
                                      </div>
                                    </div>
                                    {validationEdit.touched.client && validationEdit.errors.client && (
                                      <p className="invalid-feedback d-block" type="invalid">
                                        {validationEdit.errors.client}
                                      </p>
                                    )}
                                  </div>
                                  <div className="mb-3">
                                    <Label htmlFor="company-field" className="form-label">
                                      Perusahaan
                                    </Label>
                                    <div className="position-relative">
                                      <Select
                                        name="company"
                                        value={validationEdit.values.company}
                                        placeholder="Pilih Perusahaan"
                                        isDisabled={userType === "admin" || userType === "client" ? false : true}
                                        onChange={(e) => {
                                          dispatch(setBranchSelect(null));
                                          dispatch(setCompanySelect(e));
                                          validationEdit.setFieldValue("company", e);
                                        }}
                                        options={companyList}></Select>
                                      <div
                                        className="position-absolute"
                                        style={{
                                          top: "12px",
                                          left: "-24px",
                                        }}>
                                        {companyLoading && (
                                          <Spinner color="primary" size="sm">
                                            Loading...
                                          </Spinner>
                                        )}
                                      </div>
                                    </div>
                                    {validationEdit.touched.company && validationEdit.errors.company && (
                                      <p className="invalid-feedback d-block" type="invalid">
                                        {validationEdit.errors.company}
                                      </p>
                                    )}
                                  </div>
                                  <div className="mb-3">
                                    <Label htmlFor="branch-field" className="form-label">
                                      {t("Cabang / Proyek")}
                                    </Label>
                                    <Select
                                      name="branch"
                                      value={validationEdit.values.branch}
                                      placeholder="Pilih Proyek"
                                      onChange={(e) => {
                                        dispatch(setBranchSelect(e));
                                        validationEdit.setFieldValue("branch", e);
                                      }}
                                      options={branchList}
                                    ></Select>
                                    {validationEdit.touched.branch && validationEdit.errors.branch && <p className="text-error">{validationEdit.errors.luas}</p>}
                                  </div>
                                  <div className="mb-3 col-lg-12">
                                    <Label htmlFor="active-status" className="form-label">
                                      Status
                                    </Label>
                                    <Select
                                      name="lf_status_legal"
                                      value={validationEdit.values.lf_status_legal}
                                      placeholder="Pilih Status"
                                      onChange={(e) => {
                                        validationEdit.setFieldValue("lf_status_legal", e);
                                      }}
                                      options={legalStatusList} ></Select>
                                  </div>
                                  <div className="mb-1">
                                    <Input name="isHook" id="isHook-field" className="form-check-input" type="checkbox" onChange={validationEdit.handleChange} onBlur={validationEdit.handleBlur} checked={validationEdit.values.isHook} /> &nbsp;
                                    <Label htmlFor="isHook-field" className="form-label">
                                      Jenis Pecahan Adalah Tanah Hook
                                    </Label>
                                  </div>

                                  <div className="row">
                                    <div className="mb-3 col-lg-8">
                                      <Label htmlFor="name-field" className="form-label">
                                        {t("Nama")}
                                      </Label>
                                      <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama Manual" type="text" validate={{ required: { value: true } }} onChange={validationEdit.handleChange} onBlur={validationEdit.handleBlur} value={validationEdit.values.name ?? ""} invalid={validationEdit.touched.name && validationEdit.errors.name ? true : false} />
                                      {validationEdit.touched.name && validationEdit.errors.name && <FormFeedback type="invalid">{validationEdit.errors.name}</FormFeedback>}
                                    </div>
                                    <div className="mb-3 col-lg-4">
                                      <label className="form-label" htmlFor="land_size">
                                        Luas Tanah
                                      </label>
                                      <Input type="number" className="form-control" id="land_size" placeholder="isi luas tanah" name="land_size" value={validationEdit.values.land_size || 0} onBlur={validationEdit.handleBlur} onFocus={(e) => e.target.select()} onChange={(e) => validationEdit.setFieldValue("land_size", e.target.value)} />
                                    </div>
                                  </div>
                                  <div className="mb-3">
                                    <Label htmlFor="nibel-field" className="form-label">
                                      {t("NIB EL")}
                                    </Label>
                                    <Input name="nibel" id="nibel-field" className="form-control" placeholder="Isi NIB El" type="text" validate={{ required: { value: true } }} onChange={validationEdit.handleChange} onBlur={validationEdit.handleBlur} value={validationEdit.values.nibel ?? ""} invalid={validationEdit.touched.nibel && validationEdit.errors.nibel ? true : false} />
                                    {validationEdit.touched.nibel && validationEdit.errors.nibel && <FormFeedback type="invalid">{validationEdit.errors.nibel}</FormFeedback>}
                                  </div>
                                </Col>
                                <Col lg={7}>
                                  <div className="mb-3">
                                    <Label htmlFor="active-status" className="form-label">
                                      Dasar Induk
                                    </Label>
                                    <Select
                                      name="legalmaster"
                                      value={validationEdit.values.legalmaster}
                                      placeholder="Induk"
                                      isMulti
                                      onChange={(opt, { option }) => {
                                        let newOpts = opt;
                                        if (option && option.value === "all") {
                                          let filteredOptions = clone(legalMasterList);
                                          filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                                          newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                                        }
                                        validationEdit.setFieldValue("legalmaster", newOpts);
                                      }}
                                      options={legalMasterList}
                                    ></Select>
                                    {validationEdit.touched.legalmaster && validationEdit.errors.legalmaster && <p className="text-error">{validationEdit.errors.legalmaster}</p>}
                                  </div>
                                  <div className="mb-3">
                                    <Label htmlFor="targetat-field" className="form-label">
                                      Target
                                    </Label>
                                    <Flatpickr
                                      name="targetat"
                                      className="form-control"
                                      placeholder="Pilih Tanggal"
                                      options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                      value={validationEdit.values.targetat ?? ""}
                                      onChange={(o, e) => {
                                        validationEdit.setFieldValue("targetat", e);
                                      }}
                                    />
                                    {validationEdit.touched.targetat && validationEdit.errors.targetat ? (
                                      <p className="text-danger" type="invalid">
                                        {validationEdit.errors.targetat}
                                      </p>
                                    ) : null}
                                  </div>
                                  <div className="mb-3">
                                    <Label htmlFor="behalf_company-field" className="form-label">
                                      Atas Nama PT
                                    </Label>
                                    <Input name="behalf_company" id="behalf_company-field" className="form-control" placeholder="Isi Atas Nama PT" type="text" onChange={validationEdit.handleChange} onBlur={validationEdit.handleBlur} value={validationEdit.values.behalf_company} invalid={validationEdit.touched.behalf_company && validationEdit.errors.behalf_company ? true : false} />
                                    {validationEdit.touched.behalf_company && validationEdit.errors.behalf_company ? <FormFeedback type="invalid">{validationEdit.errors.behalf_company}</FormFeedback> : null}
                                  </div>
                                  <div className="mb-3 d-none">
                                    <Label htmlFor="behalf_customer-field" className="form-label">
                                      Atas Nama Pembeli
                                    </Label>
                                    <Input name="behalf_customer" id="behalf_customer-field" className="form-control" placeholder="Isi Atas Nama Pembeli" type="text" onChange={validationEdit.handleChange} onBlur={validationEdit.handleBlur} value={validationEdit.values.behalf_customer} invalid={validationEdit.touched.behalf_customer && validationEdit.errors.behalf_customer ? true : false} />
                                    {validationEdit.touched.behalf_customer && validationEdit.errors.behalf_customer ? <FormFeedback type="invalid">{validationEdit.errors.behalf_customer}</FormFeedback> : null}
                                  </div>
                                  <div className="mb-3">
                                    <Label htmlFor="des-field" className="form-label">
                                      Keterangan
                                    </Label>
                                    <Input name="description" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validationEdit.handleChange} onBlur={validationEdit.handleBlur} value={validationEdit.values.description ?? ""} />
                                  </div>
                                  <div className="mb-3 d-flex justify-content-between">
                                    <Label htmlFor="taskFiles" className="form-label me-3">
                                      Dokumen
                                    </Label>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-label btn-soft-success"
                                      onClick={() => {
                                        toggleMedia();
                                      }}
                                    >
                                      <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                                    </button>
                                  </div>
                                  {assetFiles.map((assetFile, i) => {
                                    if (assetFile.isDeleted) {
                                      return null;
                                    } else {
                                      return (
                                        <div key={i} className="border-bottom mb-3">
                                          <div className="d-flex justify-content-between mb-3 align-items-center">
                                            <div className="me-2">
                                              <img src={assetFile.filename === "" ? defaultImg : `${api.MEDIA_URL}/media/${assetFile.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                            </div>
                                            <div className="text-truncate">{assetFile.originalname}</div>
                                            <div>
                                              <Link
                                                to="#"
                                                className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                                onClick={(e) => {
                                                  handleDeleteFile(assetFile);
                                                }}
                                              >
                                                <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                              </Link>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    }
                                  })}
                                </Col>
                              </>
                            ) : (
                              <>
                                <Col lg={4}>
                                  <div className="mb-3">
                                    <Label htmlFor="latitude-field" className="form-label">
                                      Grup Usaha
                                    </Label>
                                    <div className="position-relative">
                                      <Select
                                        name="client"
                                        value={validation.values.client}
                                        isDisabled={userType === "admin" || userType === "client" ? false : true}
                                        placeholder="Pilih Grup Usaha"
                                        onChange={(e) => {
                                          validation.setFieldValue("client", e);
                                        }}
                                        options={clientList}
                                      ></Select>
                                      <div
                                        className="position-absolute"
                                        style={{
                                          top: "12px",
                                          left: "-24px",
                                        }}
                                      >
                                        {clientLoading && (
                                          <Spinner color="primary" size="sm">
                                            Loading...
                                          </Spinner>
                                        )}
                                      </div>
                                    </div>
                                    {validation.touched.client && validation.errors.client && (
                                      <p className="invalid-feedback d-block" type="invalid">
                                        {validation.errors.client}
                                      </p>
                                    )}
                                  </div>
                                  <div className="mb-3">
                                    <Label htmlFor="latitude-field" className="form-label">
                                      Perusahaan
                                    </Label>
                                    <div className="position-relative">
                                      <Select
                                        name="company"
                                        value={validation.values.company}
                                        placeholder="Pilih Perusahaan"
                                        isDisabled={userType === "admin" || userType === "client" ? false : true}
                                        onChange={(e) => {
                                          setDepartmentList([]);
                                          dispatch(setBranchSelect(null));
                                          dispatch(setCompanySelect(e));
                                          validation.setFieldValue("company", e);
                                          handleGetDepartment(e.value);
                                        }}
                                        options={companyList}
                                      ></Select>
                                      <div
                                        className="position-absolute"
                                        style={{
                                          top: "12px",
                                          left: "-24px",
                                        }}
                                      >
                                        {companyLoading && (
                                          <Spinner color="primary" size="sm">
                                            Loading...
                                          </Spinner>
                                        )}
                                      </div>
                                    </div>
                                    {validation.touched.company && validation.errors.company && (
                                      <p className="invalid-feedback d-block" type="invalid">
                                        {validation.errors.company}
                                      </p>
                                    )}
                                  </div>
                                  <div className="mb-3">
                                    <Label htmlFor="address-field" className="form-label">
                                      {t("Cabang / Proyek")}
                                    </Label>
                                    <Select
                                      name="branch"
                                      value={validation.values.branch}
                                      placeholder="Pilih Proyek"
                                      onChange={(e) => {
                                        dispatch(setBranchSelect(e));
                                        validation.setFieldValue("branch", e);
                                      }}
                                      options={branchList}
                                    ></Select>
                                    {validation.touched.branch && validation.errors.branch && <p className="text-error">{validation.errors.luas}</p>}
                                  </div>
                                  <div className="mb-3 col-lg-12">
                                    <Label htmlFor="active-status" className="form-label">
                                      Jenis Pecahan
                                    </Label>
                                    <Select
                                      name="lf_status_legal"
                                      value={validation.values.lf_status_legal}
                                      placeholder="Pilih Jenis Pecahan"
                                      onChange={(e) => {
                                        validation.setFieldValue("lf_status_legal", e);
                                      }}
                                      options={legalStatusList}
                                    ></Select>
                                  </div>
                                  <div className="mb-3">
                                    <Input name="isHook" id="isHook-field" className="form-check-input" type="checkbox" onChange={validation.handleChange} onBlur={validation.handleBlur} checked={validation.values.isHook} /> &nbsp;
                                    <Label htmlFor="isHook-field" className="form-label">
                                      Jenis Pecahan Adalah Tanah Hook
                                    </Label>
                                  </div>
                                  <div className="row">
                                    <div className="mb-3 col-lg-8">
                                      <Label htmlFor="name-field" className="form-label">
                                        {t("Nama")}
                                      </Label>
                                      <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama Manual" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                                      {validation.touched.name && validation.errors.name && <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>}
                                    </div>
                                    <div className="mb-3 col-lg-4">
                                      <label className="form-label" htmlFor="land_size">
                                        Luas Tanah
                                      </label>
                                      <Input type="number" className="form-control" id="land_size" placeholder="isi luas tanah" name="land_size" value={validation.values.land_size || 0} onBlur={validation.handleBlur} onFocus={(e) => e.target.select()} onChange={(e) => validation.setFieldValue("land_size", e.target.value)} />
                                    </div>
                                  </div>
                                  <div className="mb-3">
                                    <Label htmlFor="nibel-field" className="form-label">
                                      {t("NIB EL")}
                                    </Label>
                                    <Input name="nibel" id="nibel-field" className="form-control" placeholder="Isi NIB El" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.nibel ?? ""} invalid={validation.touched.nibel && validation.errors.nibel ? true : false} />
                                    {validation.touched.nibel && validation.errors.nibel && <FormFeedback type="invalid">{validation.errors.nibel}</FormFeedback>}
                                  </div>
                                </Col>
                                <Col lg={8}>

                                  <div className="mb-3">
                                    <Label htmlFor="active-status" className="form-label">
                                      INDUK
                                    </Label>
                                    <Select
                                      name="legalmaster"
                                      value={validation.values.legalmaster}
                                      placeholder="Induk"
                                      isMulti
                                      onChange={(opt, { option }) => {
                                        let newOpts = opt;
                                        if (option && option.value === "all") {
                                          let filteredOptions = clone(legalMasterList);
                                          filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                                          newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                                        }
                                        validation.setFieldValue("legalmaster", newOpts);
                                      }}
                                      options={legalMasterList}
                                    ></Select>
                                    {validation.touched.legalmaster && validation.errors.legalmaster && <p className="text-error">{validation.errors.legalmaster}</p>}
                                  </div>
                                  <div className="mb-3">
                                    <Label htmlFor="active-status" className="form-label">
                                      Blok
                                    </Label>
                                    <Select
                                      name="block"
                                      placeholder="Blok"
                                      value={validation.values.block}
                                      isMulti
                                      onChange={(opt, { option }) => {
                                        let newOpts = opt;
                                        if (option && option.value === "all") {
                                          let filteredOptions = clone(blockList);
                                          filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                                          newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                                        }
                                        validation.setFieldValue("block", newOpts);
                                        let arrUnit = [];
                                        newOpts.forEach((block) => {
                                          (productVarians || []).forEach((item) => {
                                            const varian = item.pvar_product ? item.pvar_product : "";
                                            const category = varian.product_category ? varian.product_category.name : "";
                                            const blck = varian.product_block ? varian.product_block.id : "";
                                            const branch = varian.branchId ? varian.branchId : "";
                                            const blck_name = varian.product_block ? varian.product_block.name : "";
                                            const name = blck_name + "-" + varian.name;
                                            const id = item.id;
                                            const barcode = item.barcode;
                                            const sku = item.sku;
                                            const brandId = item.brandId;
                                            const productId = item.productId;
                                            if (block.value === blck) {
                                              if (varian.branchId === branchIdSelected) {
                                                arrUnit.push({ label: name, name: name, isHook: false, barcode: barcode, sku: sku, value: productId, brandId: brandId, productId: productId, productVarianId: id });
                                                if (item.land_excess > 0) {
                                                  arrUnit.push({ label: name + 'A', name: name + 'A', isHook: true, barcode: barcode, sku: sku, value: productId, brandId: brandId, productId: productId, productVarianId: id });
                                                }
                                              }
                                            }
                                          });
                                        });
                                        validation.setFieldValue(
                                          "unit",
                                          arrUnit
                                            .reduce((unique, o) => {
                                              if (!unique.some((obj) => obj.label === o.label && obj.value === o.value)) {
                                                unique.push(o);
                                              }
                                              return unique;
                                            }, [])
                                            .sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" }))
                                        );
                                      }}
                                      options={blockList}
                                    ></Select>
                                    {validation.touched.block && validation.errors.block && (
                                      <small className="text-danger" type="invalid">
                                        {validation.errors.block}
                                      </small>
                                    )}
                                  </div>
                                  <div className="mb-3">
                                    <Label htmlFor="active-status" className="form-label">
                                      Unit
                                    </Label>
                                    <Select
                                      name="unit"
                                      value={validation.values.unit}
                                      placeholder="Blok Rumah Terkait"
                                      isMulti
                                      onChange={(opt, { option }) => {
                                        var block = validation.values.block || [];
                                        let newOpts = opt;
                                        if (option && option.value === "all") {
                                          let filteredOptions = clone(productList);
                                          filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                                          newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                                        }
                                        validation.setFieldValue("unit", newOpts);

                                        for (const item of newOpts) {
                                          const findVarian = productVarians.find((d) => d.id === item.value);
                                          let dataBlock = block.find((d) => d.label === findVarian?.pvar_product?.product_block?.name);
                                          if (!dataBlock) block.push({ label: findVarian?.pvar_product?.product_block?.name, value: findVarian?.pvar_product?.product_block?.id });
                                        }
                                        validation.setFieldValue("block", block);
                                      }}
                                      options={productList}
                                      noOptionsMessage={(e) => "Type User to get option"}
                                    ></Select>
                                  </div>
                                  <div className="mb-3">
                                    <Label htmlFor="behalf_company-field" className="form-label">
                                      Atas Nama PT
                                    </Label>
                                    <Input name="behalf_company" id="behalf_company-field" className="form-control" placeholder="Isi Atas Nama PT" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.behalf_company} invalid={validation.touched.behalf_company && validation.errors.behalf_company ? true : false} />
                                    {validation.touched.behalf_company && validation.errors.behalf_company ? <FormFeedback type="invalid">{validation.errors.behalf_company}</FormFeedback> : null}
                                  </div>
                                  <div className="mb-3 d-none">
                                    <Label htmlFor="behalf_customer-field" className="form-label">
                                      Atas Nama Pembeli
                                    </Label>
                                    <Input name="behalf_customer" id="behalf_customer-field" className="form-control" placeholder="Isi Atas Nama Pembeli" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.behalf_customer} invalid={validation.touched.behalf_customer && validation.errors.behalf_customer ? true : false} />
                                    {validation.touched.behalf_customer && validation.errors.behalf_customer ? <FormFeedback type="invalid">{validation.errors.behalf_customer}</FormFeedback> : null}
                                  </div>
                                  <div className="mb-3">
                                    <Label htmlFor="des-field" className="form-label">
                                      Keterangan
                                    </Label>
                                    <Input name="description" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                                  </div>
                                  <div className="mb-3 d-flex justify-content-between">
                                    <Label htmlFor="taskFiles" className="form-label me-3">
                                      Dokumen
                                    </Label>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-label btn-soft-success"
                                      onClick={() => {
                                        toggleMedia();
                                      }}
                                    >
                                      <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                                    </button>
                                  </div>
                                  {assetFiles.map((assetFile, i) => {
                                    if (assetFile.isDeleted) {
                                      return null;
                                    } else {
                                      return (
                                        <div key={i} className="border-bottom mb-3">
                                          <div className="d-flex justify-content-between mb-3 align-items-center">
                                            <div className="me-2">
                                              <img src={assetFile.filename === "" ? defaultImg : `${api.MEDIA_URL}/media/${assetFile.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                            </div>
                                            <div className="text-truncate">{assetFile.originalname}</div>
                                            <div>
                                              <Link
                                                to="#"
                                                className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                                onClick={(e) => {
                                                  handleDeleteFile(assetFile);
                                                }}
                                              >
                                                <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                              </Link>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    }
                                  })}
                                </Col>
                              </>
                            )}
                          </Row>
                        </CardBody>
                      </ModalBody>
                      <div className="modal-footer">
                        <div className="hstack gap-2 justify-content-end">
                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={() => {
                              setModal(false);
                              validation.resetForm({});
                            }}
                          >
                            TUTUP
                          </button>

                          <button type="submit" className="btn btn-success" disabled={loading}>
                            <span className="d-flex align-items-center">
                              SIMPAN
                              {loading && (
                                <Spinner size="sm" className="flex-shrink-0" role="status">
                                  Loading...
                                </Spinner>
                              )}
                            </span>
                          </button>
                        </div>
                      </div>
                    </Form>
                  </Modal>
                  <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
                </CardBody>
              </Card>
            </Col>

            <Col lg={3}>
              <Card>
                <div className="card-body">
                  <table className="table align-middle table-nowrap mb-3">
                    <thead className="table-active">
                      <tr>
                        <th scope="col" className="p-2 pt-3 pb-3">
                          LAMPIRAN DOKUMEN PENJUALAN:
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {info?.lfp?.product_sales.length > 0 && (info?.lfp?.product_sales[0]?.sls_ds?.sales_file || []).map((file, key) => {
                        let src;
                        return (
                          <tr
                            key={key + "filehak"}
                            className="cursor-pointer"
                            onClick={() => {
                              const typeFile = file.filename.split(".");
                              if (typeFile[typeFile.length - 1] === "x-compressed") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else if (typeFile[typeFile.length - 1] === "sheet") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else if (typeFile[typeFile.length - 1] === "pdf") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else {
                                //
                              }
                            }}
                          >
                            <td>
                              <div className="d-flex">
                                <div className="flex-shrink-0 fs-17 me-2 filelist-icon">
                                  <span className="fs-18 text-info">{renderIcon(file.filename)}</span>
                                </div>
                                <div className="flex-grow-1 text-start">
                                  <p className="fw-semibold mb-1 mt-1">{file.description}</p>
                                  <p>{file.originalname}</p>
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>

                  <table className="table align-middle table-nowrap mb-3">
                    <thead className="table-active">
                      <tr>
                        <th scope="col" className="p-2 pt-3 pb-3">
                          Dokumen:
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {(info.lf_file || []).map((file, key) => {
                        let src;
                        return (
                          <tr
                            key={key + "filehak"}
                            className="cursor-pointer"
                            onClick={() => {
                              const typeFile = file.filename.split(".");
                              if (typeFile[typeFile.length - 1] === "x-compressed") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else if (typeFile[typeFile.length - 1] === "sheet") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else if (typeFile[typeFile.length - 1] === "pdf") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else {
                                //
                              }
                            }}
                          >
                            <td>
                              <div className="d-flex">
                                <div className="flex-shrink-0 fs-17 me-2 filelist-icon">
                                  <span className="fs-18 text-info">{renderIcon(file.filename)}</span>
                                </div>
                                <div className="flex-grow-1 text-start">
                                  <p className="fw-semibold mb-1 mt-1">{file.description}</p>
                                  <p>{file.originalname}</p>
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <h6 className="fw-semibold mb-2">Keterangan</h6>
                  <p className="mb-4">{info?.description} </p>
                </div>
                <CardBody className="text-center">
                  {/* {locationCord !== undefined ||
                    (locationCord !== null && (
                      <MapContainer center={locationCord} zoom={12} style={{ height: "300px" }}>
                        <TileLayer attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                        <Marker position={locationCord}>
                          <Popup>{info?.lf_branch && info?.lf_branch.name ? info?.lf_branch.name : "-"}</Popup>
                        </Marker>
                      </MapContainer>
                    ))} */}

                  <table className="table border table-responsive fs-13 mb-3">
                    <tbody>
                      <tr>
                        <td className="p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                          INFORMASI LAINNYA
                        </td>
                      </tr>
                      <tr>
                        <td className="p-2">Perusahaan</td>
                        <td className="p-2">{info?.lf_company && info?.lf_company.name ? info?.lf_company.name : "-"} </td>
                      </tr>
                      <tr>
                        <td className="p-2">Dibuat Oleh</td>
                        <td className="p-2">{info?.lf_createdby && info?.lf_createdby.name ? info?.lf_createdby.name + " - " + handleValidDate(info.createdat) : "-"}</td>
                      </tr>
                      <tr>
                        <td className="p-2">Diedit Oleh</td>
                        <td className="p-2">{info?.lf_updatedby && info?.lf_updatedby.name ? info?.lf_updatedby.name + " - " + handleValidDate(info.updatedat) : "-"}</td>
                      </tr>
                    </tbody>
                  </table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <Modal id="showModalAccPayable" isOpen={modalAccPayable} centered size="lg">
          <ModalHeader className="bg-light p-3" toggle={toggleAccPayable}>
            TAGIHAN {info?.name}
          </ModalHeader>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validationAccPayable.handleSubmit();
              return false;
            }}>
            <ModalBody>
              <div className="row">
                <div className="mb-3 col-lg-4">
                  <Label htmlFor="amount-field" className="form-label">
                    Jumlah
                  </Label>
                  <CurrencyInput
                    id="amount"
                    name="amount"
                    prefix="Rp. "
                    style={{ border: "1px solid #ccc" }}
                    className="form-control product-price"
                    placeholder="Terbayar"
                    value={validationAccPayable.values.amount}
                    decimalsLimit={2}
                    onFocus={(e) => e.target.select()}
                    onValueChange={(value, name, values) => {
                      let amount = !isNaN(parseFloat(info.amount)) ? parseFloat(info.amount) : 0;
                      validationAccPayable.setFieldValue("amount", parseFloat(value));
                    }}
                  />
                  {validationAccPayable.touched.amount && validationAccPayable.errors.amount && <p className="invalid-feedback d-block" type="invalid">{validationAccPayable.errors.amount}</p>}
                </div>
                <div className="mb-3 col-lg-4">
                  <Label htmlFor="amount-field" className="form-label">
                    Tanggal Tagihan
                  </Label>
                  <Flatpickr
                    className="form-control"
                    id="datepicker-publish-input"
                    placeholder="Select transaction date"
                    options={{
                      mode: "single",
                      dateFormat: "Y/m/d",
                    }}
                    onChange={(selectedDates, dateStr) => {
                      validationAccPayable.setFieldValue("transactionat", dateStr);
                    }}
                    value={validationAccPayable.values.transactionat ?? ""} />
                </div>
                <div className="mb-3 col-lg-4">
                  <Label className="form-label">
                    Cashflow
                  </Label>
                  <Select
                    name="cashflow"
                    value={validationAccPayable.values.cashflow}
                    placeholder="Pilih Cashflow"
                    onChange={(e) => {
                      validationAccPayable.setFieldValue("cashflow", e);
                    }}
                    options={budgetList}></Select>
                  {validationAccPayable.touched.cashflow && validationAccPayable.errors.cashflow && (
                    <small className="text-danger" type="invalid">
                      {validationAccPayable.errors.cashflow}
                    </small>
                  )}
                </div>
                <div className="mb-3">
                  <Label htmlFor="address-field" className="form-label">
                    Keterangan
                  </Label>
                  <Input type="textarea" className="form-control" id="description" placeholder="Isi Keterangan " name="description" rows={3} value={validationAccPayable.values.description ?? ""} onBlur={validationAccPayable.handleBlur} onChange={validationAccPayable.handleChange} invalid={validationAccPayable.touched.description && validationAccPayable.errors.description ? true : false} />
                  {validationAccPayable.touched.description && validationAccPayable.errors.description && (
                    <small className="text-danger" type="invalid">
                      {validationAccPayable.errors.description}
                    </small>
                  )}
                </div>
              </div>
            </ModalBody>
            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => {
                    setModalAccPayable(false);
                    validationAccPayable.resetForm();
                  }}>
                  Close
                </button>
                <button type="submit" className="btn btn-success">
                  <span className="d-flex align-items-center">
                    <span className="flex-grow-1 me-2">SIMPAN TAGIHAN</span>
                    {loading && (
                      <Spinner size="sm" className="flex-shrink-0" role="status">
                        Loading...
                      </Spinner>
                    )}
                  </span>
                </button>
              </div>
            </div>
          </Form>
        </Modal>
        <Modal id="showModalDetail" isOpen={modalDetail} centered size="xl">
          <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
            {`View ${detailType}`}
          </ModalHeader>
          {info !== undefined && info !== null && (
            <>
              <PrintDocF4 innerRef={printRef} item={info} type={detailType} />
            </>
          )}

          <div className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => {
                  setModalDetail(false);
                }}
              >
                TUTUP
              </button>
              {<ButtonPrintF4 innerRef={printRef} title={`${detailType}-${info?.nama ?? ""}`} />}
            </div>
          </div>
        </Modal>
      </div >
    </>
  );
};

export default withRouter(withTranslation()(LegalFraction));
